export enum AccountStatus {
    ACTIVE,
    INACTIVE,
}
